export const locale = {
    lang: 'tr',
    data: {
        'NAV': {
            'APPLICATIONS': 'Programlar',
            'SAMPLE'        : {
                'TITLE': 'Örnek',
                'BADGE': '15'
            }
        }
    }
};



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/navigation/i18n/tr.ts